/* Common Imports */

import { styled } from "@mui/system";
import React from "react";

/* Styled Components */

const Image = styled("img")(({ theme }) => ({
	display: "flex",
	objectFit: "cover",
	height: "100%",
	width: "100%",
}));

const Container = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "flex-start",
	alignItems: "center",
	width: "100%",
	height: "100%",
	borderRadius: "1.55rem 0 0 1.55rem",
	padding: "3px 0px 1px 2.5px",
	overflow: "hidden",
	[theme.breakpoints.down("md1190")]: {
		width: "19.25rem",
		height: "11.813rem",
	},
	/* 1190 ~~Desktop Layout Start~~ */
	[theme.breakpoints.up("md1190")]: {
		width: "21.875rem",
		height: "15.875rem",
	},
}));

/*

 & Setting a constant image for when the image is not available or something goes wrong

*/

const fallbackImage: string = "/images/uploads/property.jpg";

const GridImage = ({ title, images }: { title: string; images: string }) => {
	return (
		<React.Fragment>
			<Container>
				<Image
					src={images && images !== undefined && images !== "" ? images : fallbackImage}
					alt={title}
					referrerPolicy="no-referrer"
					loading="lazy"
					width="100%"
				/>
			</Container>
		</React.Fragment>
	);
};

export default GridImage;
